<template>
  <div>
    <apexchart type="pie" :options="options" :series="series" :width="largura"></apexchart>
    {{preencherGrafico}}
  </div>
</template>
<script>
/* eslint-disable */
import VueApexCharts from "vue-apexcharts";
import Dexie from "dexie";
import BibliotecaDeCalculos from "bibliotecadecalculos-f02";
import RebanhoDeRecria from "../../class/RebanhoDeRecria";
import RebanhoDeReproducao from "../../class/RebanhoDeReproducao";

export default {
  components: {
    apexchart: VueApexCharts
  },
  data: () => ({
    options: {
      legend: {
        position: "top"
      },
      colors: [
        "#BF343F",
        "#A7E4F2",
        "#32736C",
        "#D9B504",
        "#F2811D",
        "#BFBFBF",
        "#A63C76",
        "#128BA6",
        "#F279A6",
        "#590222"
      ],
      labels: [
        "Touros",
        "Vacas",
        "F 36+",
        "F 24-36",
        "F 12-24",
        "F 0-12",
        "M 012",
        "M 12-24",
        "M 24-36",
        "M 36+"
      ],
      dataLabels: {
        enabled: true,
        formatter: function(val) {
          return (
            parseFloat(val.toFixed(2)).toLocaleString("pt-BR", {
              currency: "BRL"
            }) + " %"
          );
        }
      },
      tooltip: {
        y: {
          formatter: function(val) {
            return parseFloat(val).toFixed(2) + " %";
          }
        }
      }
    },
    series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    largura: "100%",
    comprimento: "200%",
    formulario: "",
    simulation: ""
  }),

  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    preencherGrafico: function() {
      this.$db.simulation
        .get({ code: this.simulation.code }, dado => {
          var reproducao = new RebanhoDeReproducao(dado.rebanhoReproducao);
          var recria = new RebanhoDeRecria(dado.rebanhoRecria);
          var biblioteca = [
            BibliotecaDeCalculos.RebanhoTotal(
              BibliotecaDeCalculos.RebanhoDeReproducao(reproducao),
              BibliotecaDeCalculos.RebanhoDeRecria(recria)
            )
          ];
          return biblioteca;
        })
        .then(
          g => (
            (this.series[0] = g[0].composicaoCabecaTouroUA() * 100),
            (this.series[1] = g[0].composicaoCabecaVacaUA() * 100),
            (this.series[2] = g[0].composicaoCabecaUA("femea", "36") * 100),
            (this.series[3] = g[0].composicaoCabecaUA("femea", "2436") * 100),
            (this.series[4] = g[0].composicaoCabecaUA("femea", "1224") * 100),
            (this.series[5] = g[0].composicaoCabecaUA("femea", "012") * 100),
            (this.series[6] = g[0].composicaoCabecaUA("macho", "012") * 100),
            (this.series[7] = g[0].composicaoCabecaUA("macho", "1224") * 100),
            (this.series[8] = g[0].composicaoCabecaUA("macho", "2436") * 100),
            (this.series[9] = g[0].composicaoCabecaUA("macho", "36") * 100)
          )
        );
    }
  }
};
</script>
<style scoped>
</style>
